import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logoutApi } from "../../api/authApi";
import { logout as logoutAction } from "../../redux/sessionSlice";
import { base_name } from "../../config"; // eslint-disable-line no-unused-vars -- ileride basename route için
import digifabLogo from "../../assets/digifab-logo-beyaz.png";



export default function Sidebar({ collapsed, onToggle }) {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const me = useSelector((s) => s.session?.me);

  const [showLogoutModal, setShowLogoutModal] = useState(false);


  const menuItems = [
    {
      id: "home",
      label: "Anasayfa",
      icon: "home",
      path: "/home",
    },
    {
      id: "edges",
      label: "Edge Cihazları",
      icon: "devices",
      path: "/edges",
    },
    {
      id: "tenants",
      label: me?.global_role === "superadmin" ? "Tenantlar" : "Kullanıcılar",
      icon: "business",
      path: "/tenants",
      requiredRole: ["superadmin", "admin"],
    },
    {
      id: "alarms",
      label: "Alarmlar",
      icon: "notifications",
      path: "/alarms",
    },
    {
      id: "vpn",
      label: "VPN Kullanıcıları",
      icon: "vpn",
      path: "/vpn-users",
      requiredRole: ["superadmin"], 
    },
    {
      id: "marketplace",
      label: "Marketplace",
      icon: "store",
      path: "/marketplace",
      requiredRole: ["superadmin", "admin"],
    },
  ];

  const handleLogout = async () => {
    try {
      await logoutApi();
    } catch (e) {
      // ignore
    } finally {
      localStorage.removeItem("user_info");
      dispatch(logoutAction());
      navigate("/", { replace: true });
    }
  };

  const filteredMenuItems = menuItems.filter((item) => {
    if (!item.requiredRole) return true;
    const userRole = me?.global_role || me?.tenant_role;
    return item.requiredRole.includes(userRole);
  });

  const isActive = (path) => location.pathname === path;

  return (
    <div style={{ ...styles.sidebar, width: collapsed ? 60 : 240 }}>
      {/* Logo & Toggle */}
      <div style={styles.header}>
        {!collapsed && (
          <img src={digifabLogo} alt="DigiFab" style={styles.logoImg} />
        )}
        <button style={styles.toggleBtn} onClick={onToggle}>
          {collapsed ? "→" : "←"}
        </button>
      </div>

      {/* Menu Items */}
      <nav style={styles.nav}>
        {filteredMenuItems.map((item) => (
          <button
            key={item.id}
            style={{
              ...styles.menuItem,
              ...(isActive(item.path) ? styles.menuItemActive : {}),
            }}
            onClick={() => navigate(item.path)}
            title={collapsed ? item.label : undefined}
          >
            <span style={styles.icon}>{getIcon(item.icon)}</span>
            {!collapsed && <span style={styles.label}>{item.label}</span>}
          </button>
        ))}
      </nav>

      {/* User Info & Logout */}
      <div style={styles.footer}>
        {!collapsed && (
          <div style={styles.userInfo}>
            <div style={styles.avatar}>
              {me?.full_name?.charAt(0)?.toUpperCase() || me?.email?.charAt(0)?.toUpperCase() || "U"}
            </div>
            <div style={styles.userDetails}>
              <span style={styles.userName}>{me?.full_name || me?.email}</span>
              <span style={styles.userRole}>{me?.tenant_role || me?.global_role}</span>
            </div>
          </div>
        )}
        <button style={styles.logoutBtn} onClick={() => setShowLogoutModal(true)} title="Çıkış Yap">
          {collapsed ? "⏻" : "Çıkış Yap"}
        </button>
      </div>

      {showLogoutModal && (
        <div style={styles.modalOverlay}>
          <div style={styles.modal}>
            <h3 style={styles.modalTitle}>Çıkış</h3>
            <p style={styles.modalText}>Oturum kapatmak istediğinize emin misiniz?</p>
            <div style={styles.modalButtons}>
              <button style={styles.modalBtnYes} onClick={handleLogout}>Evet</button>
              <button style={styles.modalBtnNo} onClick={() => setShowLogoutModal(false)}>Hayır</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function getIcon(name) {
  const icons = {
    home: "🏠",
    devices: "📟",
    business: "🏢",
    notifications: "🔔",
    vpn: "🔐",
    store: "🛒",
  };
  return icons[name] || "•";
}

const styles = {
  sidebar: {
    height: "100vh",
    backgroundColor: "#1a1a2e",
    color: "#fff",
    display: "flex",
    flexDirection: "column",
    transition: "width 0.3s ease",
    position: "fixed",
    left: 0,
    top: 0,
    zIndex: 1000,
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "16px",
    borderBottom: "1px solid rgba(255,255,255,0.1)",
  },
  logo: {
    fontSize: "18px",
    fontWeight: "bold",
    color: "#4fc3f7",
  },
  logoImg: {
    height: "32px",
    objectFit: "contain",
  },
  toggleBtn: {
    background: "transparent",
    border: "none",
    color: "#fff",
    fontSize: "16px",
    cursor: "pointer",
    padding: "4px 8px",
    borderRadius: "4px",
  },
  nav: {
    flex: 1,
    padding: "16px 8px",
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  menuItem: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "12px 16px",
    backgroundColor: "transparent",
    border: "none",
    color: "#b0b0b0",
    fontSize: "14px",
    cursor: "pointer",
    borderRadius: "8px",
    textAlign: "left",
    transition: "all 0.2s",
  },
  menuItemActive: {
    backgroundColor: "rgba(79, 195, 247, 0.2)",
    color: "#4fc3f7",
  },
  icon: {
    fontSize: "18px",
    width: "24px",
    textAlign: "center",
  },
  label: {
    whiteSpace: "nowrap",
  },
  footer: {
    padding: "16px",
    borderTop: "1px solid rgba(255,255,255,0.1)",
  },
  userInfo: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    marginBottom: "12px",
  },
  avatar: {
    width: "36px",
    height: "36px",
    borderRadius: "50%",
    backgroundColor: "#4fc3f7",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "16px",
    fontWeight: "bold",
    color: "#1a1a2e",
  },
  userDetails: {
    display: "flex",
    flexDirection: "column",
  },
  userName: {
    fontSize: "14px",
    fontWeight: "500",
  },
  userRole: {
    fontSize: "12px",
    color: "#888",
  },
  logoutBtn: {
    width: "100%",
    padding: "10px",
    backgroundColor: "rgba(255,255,255,0.1)",
    border: "none",
    color: "#fff",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "14px",
  },
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 2000,
  },
  modal: {
    backgroundColor: "#fff",
    borderRadius: "12px",
    padding: "32px",
    minWidth: "340px",
    boxShadow: "0 4px 24px rgba(0,0,0,0.3)",
  },
  modalTitle: {
    margin: "0 0 12px 0",
    fontSize: "20px",
    fontWeight: "600",
    color: "#1a1a2e",
  },
  modalText: {
    margin: "0 0 24px 0",
    fontSize: "14px",
    color: "#555",
  },
  modalButtons: {
    display: "flex",
    gap: "12px",
  },
  modalBtnYes: {
    padding: "8px 24px",
    backgroundColor: "#1a1a2e",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "14px",
  },
  modalBtnNo: {
    padding: "8px 24px",
    backgroundColor: "#e0e0e0",
    color: "#333",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "14px",
  },
};
